import { HeaderMenu } from '@/components/header-menu';
import styles from './profile.module.scss';
import { SettingsIcon } from '@/assets/icons';
import { Button } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import { SettingsProfile } from '@/components/settings-profile';
import { useTranslation } from 'react-i18next';

export const Profile: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.profile}>
            <HeaderMenu
                title={t('profile.profile_title')}
                marginBottom={20}
                append={
                    <Button
                        isLink
                        to={routesApp.settings}
                        className={styles.button}>
                        <SettingsIcon />
                    </Button>
                } />
            <SettingsProfile />
        </div>
    );
};
